import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, roleHome } from "../lib/auth";
import LoginView from "./LoginView";
import { toast } from "sonner";
import { apiErrorMessage } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible,setVisible]=useState(false);
  const [error,setError]=useState("");
  const [loading, setLoading] = useState(false);
  const pharmacy = new URLSearchParams(window.location.search).get("workspace") === "pharmacy";

  const onSubmit = async (e) => {
    e.preventDefault();
    if(loading)return;
    setError("");
    setLoading(true);
    try {
      const u = await login(email.trim(), password, pharmacy ? "pharmacy" : "clinical");
      setVisible(false);
      toast.success(`Welcome back, ${u.name}!`);
      const next = new URLSearchParams(window.location.search).get("next");
      if (pharmacy && !u.must_change_password && next && /^\/pharmacies\/[^/\\]+\/(?:upload-prescription(?:\?cart=1)?|checkout)$/.test(next)) { nav(next); return; }
      nav(u.must_change_password ? "/my-profile" : pharmacy ? (u.pharmacy_workspace_available ? "/pharmacy-panel" : u.role === "patient" ? "/my-account" : "/pharmacy-orders") : u.role === "patient" ? "/my-account" : roleHome(u.role));
    } catch (err) {
      setError(apiErrorMessage(err, "We couldn’t sign you in. Check your email and password, then try again."));
    } finally {
      setLoading(false);
    }
  };

  return <LoginView {...{email,setEmail,password,setPassword,visible,setVisible,loading,error,pharmacy,onSubmit}}/>;
}
